import styled from 'styled-components';
import { generateFontSizing } from 'app/styles/mixins';

export const ScoreSt = styled.div`
  position: relative;
  display: flex;
  width: 12.5rem;
  height: 12.5rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  background-size: contain;
  background-position: center center;
  background-image: url('/assets/images/rating-score-bg.png');
`;

export const ScorePlainSt = styled.div`
  position: absolute;
  width: 46.5%;
  height: 46.5%;
  border-radius: 100%;
  background: ${({ theme }) => theme.colors.white};
`;

export const ScoreTextSt = styled.div`
  position: absolute;
  z-index: 1;
  user-select: none;
`;

export const ScoreValueSt = styled.span`
  display: inline-block;
  width: 2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral800};
  ${generateFontSizing('h4')}
`;

export const ScoreMaxSt = styled.span`
  color: ${({ theme }) => theme.colors.neutral600};
  font-size: ${({ theme }) => theme.fontSizes.p2};
`;
